// extracted by mini-css-extract-plugin
export default {"usernameLink":"TopUsers_usernameLink__Juu0u"};